import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import { StyledBreadcrumbs, Wrapper } from './Breadcrumbs.styled';
import { Helmet } from 'react-helmet';

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs }) => {
  const renderCrumb = (crumb: Crumb, index: number) => {
    return (
      <span key={`crumb-${index}`}>
        <Link to={crumb.href}>{crumb.label}</Link>
        {index < crumbs.length - 1 ? <span className="split">&gt;</span> : null}
      </span>
    );
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.label,
        item: {
          '@id': crumb.href,
          name: crumb.label,
        },
      };
    }),
  };

  return (
    <StyledBreadcrumbs>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Wrapper width="normal">
        {crumbs.map((crumb, index) => renderCrumb(crumb, index))}
      </Wrapper>
    </StyledBreadcrumbs>
  );
};

interface Crumb {
  href: string;
  label: string;
}

interface BreadcrumbsProps {
  crumbs: Crumb[];
}
